var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.667 4.017a.65.65 0 0 1 .65.65v5.097l5.557-5.557a.65.65 0 1 1 .919.92l-5.557 5.556h5.097a.65.65 0 0 1 0 1.3H4.667a.65.65 0 0 1-.65-.65V4.667a.65.65 0 0 1 .65-.65Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjY2NjY2IDQuMDE2NjdDNS4wMjU2NSA0LjAxNjY3IDUuMzE2NjYgNC4zMDc2OSA1LjMxNjY2IDQuNjY2NjdMNS4zMTY2NiA5Ljc2NDFMMTAuODczNyA0LjIwNzA1QzExLjEyNzUgMy45NTMyMSAxMS41MzkxIDMuOTUzMjEgMTEuNzkyOSA0LjIwNzA1QzEyLjA0NjggNC40NjA4OSAxMi4wNDY4IDQuODcyNDUgMTEuNzkyOSA1LjEyNjI5TDYuMjM1OSAxMC42ODMzTDExLjMzMzMgMTAuNjgzM0MxMS42OTIzIDEwLjY4MzMgMTEuOTgzMyAxMC45NzQ0IDExLjk4MzMgMTEuMzMzM0MxMS45ODMzIDExLjY5MjMgMTEuNjkyMyAxMS45ODMzIDExLjMzMzMgMTEuOTgzM0w0LjY2NjY2IDExLjk4MzNDNC4zMDc2OCAxMS45ODMzIDQuMDE2NjYgMTEuNjkyMyA0LjAxNjY2IDExLjMzMzNMNC4wMTY2NiA0LjY2NjY3QzQuMDE2NjYgNC4zMDc2OSA0LjMwNzY4IDQuMDE2NjcgNC42NjY2NiA0LjAxNjY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";